export default __webpack_public_path__ + "static/media/logo-footer.1d557934.svg";